import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminImageReport = lazy(() => import("@/pages/admin/AdminImageReport"));

export const Route = createFileRoute("/admin/bildrapport")({
  component: () => <AdminImageReport />,
});
